$(function () {

	// Add hover effect to main nav
	$(".dtg-citycycling-sum").each(function () {
		const $container = $(this);

		$container.find(".dtg-citycycling-list-item-value").each(function () {

			const $item = $(this);
			const link = $item.data('citycycling-value');
			const decimalsData = $item.data('citycycling-decimals');
			const decimals = decimalsData ? parseInt(decimalsData) : 0;
			const isAverage = "average" === $item.data('citycycling-calculate');

			let sum = 0;
			let count = 0;

			$("*[data-citycycling-value-" + link + "]").each(function () {
				const value = parseFloat($(this).data("citycycling-value-" + link));
				if (value) {
					sum += value;
					count++;
				}
			});

			let result = sum;

			if (isAverage) {
				result = sum / count;
			}


			$item.text(parseFloat(result).toLocaleString('de-DE', {
				minimumFractionDigits: decimals,
				maximumFractionDigits: decimals,
			}));

		});

	});

});



